var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.isAuthenticatingClient)?_c('div',[_c('LandingInitialization')],1):_vm._e(),(_vm.isClientAuthenticationFailed)?_c('div',[_c('Error500')],1):_vm._e(),(_vm.isClientAuthenticated)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }